import { clsx } from 'clsx';

interface LogoProps {
  size?: number;
  withText?: boolean;
  /** Wordmark colour context: follows the theme (default) or forces ink on cream sections. */
  tone?: 'theme' | 'ink' | 'white';
  className?: string;
}

/**
 * Tradelyzer mark: a "T" whose stem is a candlestick (body + wick) on a lime tile.
 * Keep in sync with public/favicon.svg.
 */
export function LogoMark({ size = 26, className }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden className={clsx('shrink-0', className)}>
      <rect width="64" height="64" rx="14" fill="#d4ff1a" />
      <rect x="14" y="13" width="36" height="8" rx="2" fill="#040404" />
      <rect x="27" y="21" width="10" height="22" rx="2" fill="#040404" />
      <rect x="30.5" y="43" width="3" height="9" rx="1.5" fill="#040404" />
    </svg>
  );
}

export function Logo({ size = 26, withText = true, tone = 'theme', className }: LogoProps) {
  return (
    <div className={clsx('flex items-center gap-2', className)}>
      <LogoMark size={size} />
      {withText && (
        <span className={clsx('text-[17px] font-semibold tracking-[-0.02em]', tone === 'ink' ? 'text-ink' : tone === 'white' ? 'text-white' : 'text-dark-text')}>
          Tradelyzer
        </span>
      )}
    </div>
  );
}
